'use client';
import { Fragment } from 'react';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';

import YouTubeVideo from 'src/components/YouTubeVideo';

type Props = {
    source: string | null;
    onClose: () => void;
};

export default function VideoPlayer({ source = null, onClose }: Props) {
    return (
        <Transition appear show={!!source} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="bg-dark-green/75 fixed inset-0" aria-hidden="true" />
                </TransitionChild>

                <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                    <TransitionChild
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95">
                        <DialogPanel className="bg-primary mx-auto w-full drop-shadow-lg md:w-4/5 lg:w-2/3">
                            <YouTubeVideo source={source} onVideoEnded={onClose} />
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </Transition>
    );
}
